import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {ReactiveFormsModule} from '@angular/forms';
import {FormFieldModule} from '../../../../../core/component/form-field/form-field.module';
import {
    ExamFormDefinitionFormValueJsonHandlerComponent
} from './exam-form-definition-form-value-json-handler.component';
import {
    ExamFormDefinitionSummarySelectFilterModule
} from '../../../api/component/exam-form-definition-summary-select-filter/exam-form-definition-summary-select-filter.module';
@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        IonicModule,
        FormFieldModule,
        ExamFormDefinitionSummarySelectFilterModule,
    ],
    declarations: [
        ExamFormDefinitionFormValueJsonHandlerComponent,
    ],
    exports: [
        ExamFormDefinitionFormValueJsonHandlerComponent
    ],
})
export class ExamFormDefinitionFormValueJsonHandlerModule {
}
